import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from '@reduxjs/toolkit'
import { HttpService } from "../../services/HttpService";
import Store from "..";

const initialState = {
  categoryPrenotation: [],
  timeTable: [],
  filter: [],
  timeslotUpdate: 0,
  selectCategoryPrenotation: "",
  filterType: "list",
  timeslotDetailUpdate: 0,
}

export const deleteTimeslotById = (timeslotId: any) => async (dispacth: any) => {
  try {
    const eventId = Store.getState().login.eventId;
    if (timeslotId) {
      const result = await HttpService.delete(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/timeslot/${timeslotId}`);
      if (result.status === 200) {
        let timeTable: any = [...Store.getState().timeslot.timeTable];
        if (result.data.deleted) {
          dispacth(updateTimetable(timeTable.map((timeslot: any) => { let timeslotEdit = Object.assign({}, timeslot); if (timeslotEdit._id === timeslotId) { timeslotEdit.deleted = true } return timeslotEdit })));
        }
        else {
          dispacth(updateTimetable(timeTable.filter((timeslot: any) => timeslot._id !== timeslotId)));
        }

      }

      return result
    }

  }
  catch (e: any) {
    console.log("Load CategoryTimeslot", e);
    return e.response;
  }
}

export const deleteTimeslotCategory = (timeslotCategoryId: any) => async (dispacth: any) => {
  try {
    const eventId = Store.getState().login.eventId;
    const result = await HttpService.delete(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/timeslot-category/${timeslotCategoryId}`);
    return result

  }
  catch (error: any) {
    console.log("Delete CategoryTimeslot", error);
    throw error;
  }
}

export const createTimeslot = (timeslotObjectCreate: any) => async (dispacth: any) => {
  try {
    const eventId = Store.getState().login.eventId;
    if (timeslotObjectCreate) {
      const result = await HttpService.post(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/timeslot/create/automatic`, timeslotObjectCreate);
      await dispacth(loadCategoryTimeslot(false, false));
      return result
    }

  }
  catch (e: any) {
    console.log("Load CreateTimeslot", e);
    return e.response;
  }
}
export const updateTimeslot = (timeslot: any, timeslotId: any) => async (dispacth: any) => {
  try {
    const eventId = Store.getState().login.eventId;
    if (timeslotId) {
      const result = await HttpService.put(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/timeslot/${timeslotId}`, timeslot);
      dispacth(loadCategoryTimeslot(false, false));
      return result
    }

  }
  catch (e: any) {
    console.log("Load CategoryTimeslot", e);
    return e.response;
  }
}

export const repeatTimeslots = (timeslot: any) => async (dispacth: any) => {
  try {
    const eventId = Store.getState().login.eventId;
    if (timeslot) {
      const result = await HttpService.post(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/timeslot/create/automatic`, timeslot);
      dispacth(loadCategoryTimeslot(false, false));
      return result
    }

  }
  catch (e: any) {
    console.log("Load Repeat Timeslot", e);
    return e.response;
  }
}
export const createCategory = (timeslotCategory: any) => async (dispacth: any) => {
  try {
    const eventId = Store.getState().login.eventId;
    delete timeslotCategory._id
    const result = await HttpService.post(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/timeslot-category`, timeslotCategory);
    await dispacth(loadCategoryTimeslot());
  }
  catch (error) {
    console.log("Create CategoryTimeslot", error);
    throw error;
  }
}
export const updateCategory = (timeslotCategory: any) => async (dispacth: any) => {
  try {
    const eventId = Store.getState().login.eventId;
    if (timeslotCategory._id) {
      await HttpService.put(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/timeslot-category/${timeslotCategory._id}`, timeslotCategory);
      await dispacth(loadCategoryTimeslot());
    }

  }
  catch (e) {
    console.log("Load CategoryTimeslot", e);
    throw e;
  }
}

export const deleteTimeslotByCategory = (id: string) => async (dispacth: any) => {
  try {
    const eventId = Store.getState().login.eventId;
    if (eventId && id) {
      const response = await HttpService.delete(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/timeslot/timeslot-category/${id}`);

      // const resposeTimeTable = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/timetable`);
      // let timetable: any = [];
      // if (resposeTimeTable.data) {
      //   for (let index = 0; index < resposeTimeTable.data.length; index++) {
      //     const element = resposeTimeTable.data[index];
      //     if (element.events) {
      //       element.events.forEach((element1: any) => {
      //         timetable.push(element1);
      //       });
      //     }

      //   }
      // }
      // dispacth(updateTimetable(timetable));

    }
  }
  catch (e) {
    console.log("Delete Timeslot by Category", e);
  }
}
export const deleteTimeslotAll = () => async (dispacth: any) => {
  try {
    const eventId = Store.getState().login.eventId;
    if (eventId) {
      const response = await HttpService.delete(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/timeslot`);

      // const resposeTimeTable = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/timetable`);
      // let timetable: any = [];
      // if (resposeTimeTable.data) {
      //   for (let index = 0; index < resposeTimeTable.data.length; index++) {
      //     const element = resposeTimeTable.data[index];
      //     if (element.events) {
      //       element.events.forEach((element1: any) => {
      //         timetable.push(element1);
      //       });
      //     }

      //   }
      // }
      // dispacth(updateTimetable(timetable));

    }
  }
  catch (e) {
    console.log("Delete Timeslot", e);
  }
}


/**
 * Check new services
 * @param eventUpdate call the api to check if there are any new services to add
 * @returns {Promise}
 */
export const checkNewServices = async (eventId: string): Promise<any> => {
  try {
    return await HttpService.post(`${process.env.REACT_APP_API}/t4event/api/v01/federfarma/event-update/${eventId}`, {});
  }
  catch (error) {
    console.log("Error checkNewServices", error)
  }
}
/**
 * Loads timelot categories and timetable
 * @param eventUpdate if true calls an additional API to sync timeslot categories with federfarma
 * @returns 
 */
export const loadCategoryTimeslot = (eventUpdate = false, updateTimeslotCategory = true) => async (dispacth: any) => {
  try {
    const eventId = Store.getState().login.eventId;
    if (eventId) {
      if (eventUpdate) {
        await checkNewServices(eventId)
      }
      if (updateTimeslotCategory) {
        const response = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/timeslot-category`);
        dispacth(updateCategoryTimeslot(response.data));
        dispacth(UpdateFilterCategory(response.data.map((category: any) => category._id)));
      }

      // const resposeTimeTable = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/timetable`);
      // let timetable: any = [];
      // if (resposeTimeTable.data) {
      //   for (let index = 0; index < resposeTimeTable.data.length; index++) {
      //     const element = resposeTimeTable.data[index];
      //     if (element.events) {
      //       element.events.forEach((element1: any) => {
      //         timetable.push(element1);
      //       });
      //     }

      //   }
      // }
      // dispacth(updateTimetable(timetable));

    }
  }
  catch (e) {
    console.log("Load CategoryTimeslot", e);
  }
}

// updates category array used in the left bar of manager timeslot 
export const UpdateFilterCategory = (filterCategory: any) => async (dispacth: any) => {
  try {
    let a = Object.assign([], filterCategory)
    dispacth(updateFilter(a));
  }
  catch (e) {
    console.log("Load CategoryTimeslot", e);
  }
}

const timeslotReducer = createSlice({
  name: 'Timeslot',
  initialState,
  reducers: {
    updateCategoryTimeslot(state, action: PayloadAction<any>) {
      state.categoryPrenotation = action.payload;
    },
    updateTimetable(state, action: PayloadAction<any>) {
      state.timeTable = action.payload;
    },
    updateFilter(state, action: PayloadAction<any>) {
      state.filter = action.payload;
    },
    forceTimeslotUpdate(state) {
      state.timeslotUpdate++;  // update to trigger a days list 
    },
    updateSelectCategoryPrenotation(state, action: PayloadAction<any>) {
      state.selectCategoryPrenotation = action.payload;
    },
    changeFilterType(state, action: PayloadAction<any>) {
      state.filterType = action.payload;
    },
    forceTimeslotDetailUpdate(state) {
      state.timeslotDetailUpdate++;  // update to trigger a booking list update
    },
  }
})

export const {
  updateCategoryTimeslot,
  changeFilterType,
  forceTimeslotUpdate,
  updateTimetable,
  updateFilter,
  updateSelectCategoryPrenotation,
  forceTimeslotDetailUpdate,
} = timeslotReducer.actions

export default timeslotReducer.reducer
